export default {"src":"/_next/static/media/auth_error.8ed217dc.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};